export function stickyKeepInfo() {
  const element = document.getElementById('js-favorite-fixed-nav')
  if (element === null) return

  const option = {
    rootMargin: `${window.screen.availHeight / 4}px 0px ${document.body.clientHeight}px`,
    threshold: 1
  }

  const callback = (entries: IntersectionObserverEntry[]) => {
    if (typeof entries[0] === 'undefined') return
    element.classList.toggle('is-nav-show', !entries[0].isIntersecting)
  }

  const observer = new IntersectionObserver(callback, option)
  observer.observe(document.body)
}
